import _ from 'lodash';

export default class ThumbBucketProfileCapacity {
  constructor(item) {
    if (item) {
      this.minimumCapacity = item.minimumCapacity
        ? parseFloat(item.minimumCapacity)
        : null;
      this.maximumCapacity = item.maximumCapacity
        ? parseFloat(item.maximumCapacity)
        : null;
      this.tipRadius = item.tipRadius;

      return;
    }
    this.minimumCapacity = null;
    this.maximumCapacity = null;
    this.tipRadius = 0;
  }

  clone() {
    return _.cloneDeep(this);
  }
}
